import styled from "styled-components";

export const SActiveUsersDropdownItemContent = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
